/* eslint-disable jsx-a11y/scope */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
const ER2Update = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [formData, setFormData] = useState({
        Er2detailsId: Number(props.er2detailsId),
        NameofOccupationOccupationCodeNco20151:0,
        EducationandTechnicalEducationlevel2 :0,
        Men3 :0,
        Women4 :0, 
        Total5 :0,
        Expansionorreorganisation6:0,
        
    });


    const getdata = async () => {
        const sendData = {
            Er2detailsId: Number(props.er2detailsId),
        }
        ////console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK +'api/ER/GetER2Details', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    const maindata = data[0]
                    ////console.log(maindata)
                    setFormData({
                        NameofOccupationOccupationCodeNco20151: maindata.nameofOccupationOccupationCodeNco20151,
                        EducationandTechnicalEducationlevel2: maindata.educationandTechnicalEducationlevel2,
                        Men3: maindata.men3,
                        Women4: maindata.women4,
                        Total5: maindata.total5,
                        Expansionorreorganisation6: maindata.expansionorreorganisation6,
                        Er2detailsId: Number(props.er2detailsId),
                    });
                    setload(false)
                })


    };
    const onInputChange = async (e) => {
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
       /* //console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK +'api/ER/UpdateER2Details', {
            method: 'POST',
            headers: {  
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                   
                    // //console.log(maindata)
                    setFormData({
                        NameofOccupationOccupationCodeNco20151: maindata.nameofOccupationOccupationCodeNco20151,
                        EducationandTechnicalEducationlevel2: maindata.educationandTechnicalEducationlevel2,
                        Men3: maindata.men3,
                        Women4: maindata.women4,
                        Total5: maindata.total5,
                        Expansionorreorganisation6: maindata.expansionorreorganisation6,
                        Er2detailsId: Number(props.er2detailsId),
                    });
                    setload(false)
                })

    };

    




    useEffect(() => {
        getdata()

    }, [])

    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };
   

    return (
        load ? null :
            
        <tr scope="row"  >
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10}}>
                    {props.value}
                </td>
           
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ? <input
                        type="number"
                        id="nameofOccupationOccupationCodeNco20151"
                        className="form-control"
                        name="nameofOccupationOccupationCodeNco20151"
                        maxLength="4"
                        onKeyPress={inputHandler} 
                        style={{ textAlign: 'center' }}
                        onChange={(e) => onInputChange(e)}
                        defaultValue={formData.NameofOccupationOccupationCodeNco20151}
                    /> : formData.NameofOccupationOccupationCodeNco20151}
                

            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }} >
                    {props.edit ? <input
                        type="number"
                        id="educationandTechnicalEducationlevel2"
                        className="form-control"
                        name="educationandTechnicalEducationlevel2"
                        maxLength="4"
                        onKeyPress={inputHandler} 
                        style={{ textAlign: 'center' }}
                        onChange={(e) => onInputChange(e)}
                        defaultValue={formData.EducationandTechnicalEducationlevel2}
                    /> : formData.EducationandTechnicalEducationlevel2}

            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ?
                        <input
                            type="number"
                            id="men3"
                            className="form-control"
                            name="men3"
                            maxLength="4"
                            onKeyPress={inputHandler}
                            style={{ textAlign: 'center' }}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Men3}
                        /> : formData.Men3}


            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }} >
                    {props.edit ? <input
                        type="number"
                        id="women4"
                        className="form-control"
                        name="women4"
                        maxLength="4"
                        onKeyPress={inputHandler}
                        style={{ textAlign: 'center' }}
                        onChange={(e) => onInputChange(e)}
                        defaultValue={formData.Women4}
                    /> : formData.Women4}

            </td>
                
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ?
                        <input
                            type="number"
                            id="total5"
                            className="form-control"
                            name="total5"
                            maxLength="4"
                            onKeyPress={inputHandler}
                            style={{ textAlign: 'center' }}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Total5}
                        /> : formData.Total5}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ?
                        <input
                            type="number"
                            id="expansionorreorganisation6"
                            className="form-control"
                            name="expansionorreorganisation6"
                            maxLength="4"
                            onKeyPress={inputHandler}
                            style={{ textAlign: 'center' }}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Expansionorreorganisation6}
                        /> : formData.Expansionorreorganisation6}

                </td>
                
        </tr>
    );
};

export default ER2Update;
